import DocumentTemplate from '@/components/ui/document-template/DocumentTemplate'
import { Strong } from '@/components/ui/Strong'

function EmailLink() {
	return (
		<a href="mailto:peppercoin.dpo@marcellocarames.com" className="underline" target="_blank">
			peppercoin.dpo@marcellocarames.com
		</a>
	)
}

const CONTENT = [
	{
		title: <span id="introduction">1. Introduction</span>,
		text: (
			<span>
				This Cookies Policy (“Cookies Policy”) relates to the Website https://www.peppercoin.com (the “Site”)
				owned by Entertainment Trading Technologies Limited. In this Cookies Policy, “We”, “Us”, “Our”,
				“Ourselves” and/or “Peppercoin” shall refer to Entertainment Trading Technologies Limited, a Company
				registered in the Republic of Seychelles with company registration number 218014, whose registered
				address is at Suite 202, 2nd Floor, Eden Plaza, Eden Island, Make, Republic of Seychelles, and the terms
				“You”, “Your” and “User” refer to an identified or identifiable natural person being the user of the
				Site, App and/or client of any of Peppercoin’s services. We have appointed an European Representative,
				who may be contacted at <EmailLink />.
			</span>
		)
	},
	{
		title: <span id="contents">2. Contents</span>,
		text: (
			<ul id="contents" className="flex flex-col gap-2 [&>li>a]:underline">
				<li>
					<a href="#introduction">INTRODUCTION</a>
				</li>
				<li>
					<a href="#contents">CONTENTS</a>
				</li>
				<li>
					<a href="#what-are-cookies">WHAT ARE COOKIES?</a>
				</li>
				<li>
					<a href="#why-we-use-cookies">WHY WE USE COOKIES</a>
				</li>
				<li>
					<a href="#which-cookies-are-used">WHICH COOKIES ARE USED?</a>
				</li>
				<li>
					<a href="#placed-cookies">PLACED COOKIES</a>
				</li>
				<li>
					<a href="#control-of-cookies">CONTROL OF COOKIES</a>
				</li>
				<li>
					<a href="#contact-us">CONTACT US</a>
				</li>
				<li>
					<a href="#updates">UPDATES</a>
				</li>
			</ul>
		)
	},
	{
		title: <span id="what-are-cookies">3. What are Cookies?</span>,
		text: 'Our Site uses a technology called “cookies”. A cookie is an element of data (usually a very small file) that a website can send to Your browser, which may then store it on Your computer or mobile device. These cookies allow Us to correctly operate the Site and/or to provide You with web pages or content that are tailored to You. For example, some cookies remember Your custom preferences. This information can, in some cases, be carried from one visit of Our Site (or related site) to the next (for example, to help You avoid having to re-enter certain information when You visit the same page later). Some of these cookies may require Your consent (as explained below.) Some cookies are created for each session when You visit Our Site, while others are persistent and may remain for a number of months or years to facilitate Your access to Our Site.'
	},
	{
		title: <span id="why-we-use-cookies">4. Why we use Cookies?</span>,
		text: 'We absolutely respect Your right to privacy. We use cookies to ensure the functionality of Our Site and to make Your website experience better. You can remove any cookies already stored on Your computer or mobile device (as explained below) but this may prevent You from using parts of this Site or may cause You to see this message, or part thereof, again. Apart from the cookies We make use of Ourselves, various third-party cookies may also be stored on Your computer or mobile device. If it is the case, We strongly suggest that You read the cookie policy of any such third-party cookies.'
	},
	{
		title: <span id="which-cookies-are-used">5. Which Cookies are used?</span>,
		text: (
			<section className="flex flex-col gap-5">
				<p>Cookies may be split into two broad categories based on their lifespans, as follows:</p>
				<div className="flex flex-col gap-3">
					<Strong>A. Session Cookies</Strong>
					<p>
						Those cookies that are erased when a User closes a browser. Session cookies would, for example,
						enable Us to track the use of Our Site and to analyze and/or evaluate the effectiveness of
						future or potential marketing campaigns and activities. The information collected through these
						cookies is not stored and cannot be used to identify You as an individual. Peppercoin doesn’t
						share the information gathered through Session cookies with third-parties.
					</p>
				</div>
				<div className="flex flex-col gap-3">
					<Strong>B. Persistent Cookies</Strong>
					<p>Those cookies that remain on the User’s computer for a predetermined period of time.</p>
				</div>
				<div className="flex flex-col gap-3">
					<Strong>C. Essential and Non-Essential Cookies</Strong>
					<p>
						ESSENTIAL COOKIES are strictly necessary to ensure that the Site and/or App functions in Your
						everyday use of it or for Us to provide You with the service(s) You expect from Us. Cookies used
						for the sole purpose of carrying out or facilitating the transmission of a communication will
						also be considered as essential cookies. We do not require Your consent to use such essential
						cookies but You may still block or delete them (see below.)
					</p>
					<p>
						NON-ESSENTIAL COOKIES are not required for the essential functioning of the Site and/or App,
						although they may greatly enhance Your experience of using Our Site and/or App. Non-essential
						cookies may be used for various reasons, such as marketing purposes (to gather information about
						You browsing habits), statistical purposes (to gather information about Users) and preferences
						(to track Your custom preferences for instance by re-entering certain information when visiting
						the Site).
					</p>
				</div>
				<div className="flex flex-col gap-3">
					<Strong>D. Specific Cookies Used:</Strong>
					<div className="flex flex-col gap-3">
						<h5 className="italic">Essential, Functional or Strictly Necessary Cookies:</h5>
						<p>
							We will store data required to provide the Site functionality (eg. language preference). For
							example, We may use these cookies to provide some content and to make certain other features
							available. Some of these cookies could be managed for Us by third parties (including, in
							case, some third party providers whose services We could use on Our Site). CloudFlare will
							use cookies to operate proxy service.
						</p>
					</div>
					<div className="flex flex-col gap-3">
						<h5 className="italic">Non Essential Cookies:</h5>
						<ul className="flex flex-col gap-2 list-disc pl-10 py-3 [&>li]:pl-2">
							<li>
								Analytics cookies; These cookies collect information about how use our Site (e.g., which
								pages You visit and/or if You experience any errors) therefore they would allow Us to
								count visits and traffic sources so We can measure and improve the perfomance of Our
								Site and content.
							</li>
							<li>
								Advertising cookies; These may collect browsing and activity data on Our Site and on
								third party sites. We would use these to help Us provide You with more relevant content
								on Our Site and, in case, across Our digital marketing channels. Some advertising
								cookies could be set by third parties and allow them to track your browser and activity
								data across Our Site and, in case, other sites, which they may use to build a profile of
								your interests and target ads and content to You across third party sites.
							</li>
						</ul>
					</div>
				</div>
			</section>
		)
	},
	{
		title: <span id="placed-cookies">6. Placed Cookies</span>,
		text: (
			<div className="overflow-x-auto w-[calc(100svw-48px)] md:w-[calc(100svw-120px)]">
				<table className="border-collapse">
					<thead>
						<tr className="bg-green-10 [&>th]:border-green/30 [&>th]:border [&>th]:p-2 [&>th]:text-left">
							<th>Service</th>
							<th>Service ID</th>
							<th>Expiration</th>
							<th>Function</th>
							<th>Type</th>
						</tr>
					</thead>
					<tbody className="bg-green-20 [&>tr:nth-child(even)]:bg-green-10 [&>tr>td]:border [&>tr>td]:border-green/30 [&>tr>td]:p-2">
						<tr className="[&>td]:border [&>td]:border-green/30 [&>td]:p-2">
							<td>Cc_cookie</td>
							<td>cc_cookie</td>
							<td>6 months</td>
							<td className="min-w-[300px]">
								Holds the pop-up consent configuration so we can remember the users' preferences
							</td>
							<td>Necessary</td>
						</tr>
						<tr>
							<td>Cloudflare</td>
							<td>__cf_bm</td>
							<td>Indefinite</td>
							<td>This is dropped by Cloudflare to manage bots</td>
							<td>Necessary</td>
						</tr>
						<tr>
							<td>Absolute Labs</td>
							<td>_al</td>
							<td>Indefinite</td>
							<td>
								Store unique session ID, user country, web3 wallet browser extension infos. Stored in
								the LocalStorage by AbsoluteLabs.
							</td>
							<td>Marketing</td>
						</tr>
					</tbody>
				</table>
			</div>
		)
	},
	{
		title: <span id="control-of-cookies">7. Control of Cookies?</span>,
		text: (
			<section className="flex flex-col gap-5">
				<p>For the sake of clarity, Strictly necessary cookies do not require your consent. </p>
				<p>
					For performance, functionality, targeting and/or social media cookies, We will request your consent
					before placing them on your device. You can give your consent by continuing to use Our Site, or by
					clicking on the appropriate button on the banner displayed to You, or by going to the Cookie
					Preference Centre/Settings. If You do not wish to give consent or wish to withdraw your consent to
					any performance, functionality, targeting or social media cookies at any time, You will need to
					delete, and block or disable cookies via your browser settings; see below for more information on
					how to do this or by changing your settings in the Cookie Preference Centre/Settings.
				</p>
				<p>
					Even if We obtain Your consent to use non-essential cookies (these not being required for the proper
					functioning of the Site and/or App but enhance Your experience of using Our Site and/or App) or if
					We use essential cookies (these being necessary to ensure the Site and Apps functions in Your
					everyday use of it and where we don’t need Your consent), You can still control Your settings in
					Your browser to delete or disable cookies.
				</p>
				<p>
					If Your browser is not configured, by default, to block all or certain cookies, You may manually
					configure Your browser to either reject all cookies or control which cookies are set on Your
					computer or mobile device through the Site or App. Should You wish to reject all or certain cookies
					used by Our Site, You may modify Your web browser preferences to do so.
				</p>
				<p>
					If You reject ALL cookies (including essential cookies) then You might be unable to use some of the
					features or services available on Our Site and/or App and You might also experience a lack of full
					functionality of the Site and/or App.
				</p>
				<p>
					Usually, the information on how to change Your options regarding cookies can be obtained by
					referring to Your operating system’s manual or the ‘Help’ section of Your web browser, or by
					contacting Your Internet Service Provider.
				</p>
				<p>
					You may also find all the necessary information on how to make the necessary configuration settings
					by visiting the following helpful site{' '}
					<a href="http://www.allaboutcookies.org/" target="_blank" className="underline">
						http://www.allaboutcookies.org/
					</a>
				</p>
			</section>
		)
	},
	{
		title: <span id="contact-us">8. Contact Us</span>,
		text: (
			<span>
				If you have any questions/comments about this Cookies Policy please contact Us by sending an email to
				the following address: <EmailLink /> with the subject “COOKIES POLICY REQUEST”.
			</span>
		)
	},
	{
		title: <span id="updates">9. Updates</span>,
		text: 'We reserve the right, at Our complete discretion, to change, modify, add and/or remove portions of this Cookies Policy at any time. To let You know when we make changes to this Cookies Policy, We will amend the revision date at the top of this page. The modified Cookies Policy will apply from such revision date. We will not officially notify You about such changes, and it is therefore in Your own interest to check this Cookies Policy page from time to time so as to familiarise yourself with any changes.'
	}
]

const CookiePolicy = () => {
	return (
		<DocumentTemplate
			title="Cookie Policy"
			contentBuckets={[
				{
					bucketTitle: 'Cookie Policy',
					className: 'bg-green-10',
					content: CONTENT
				}
			]}
		/>
	)
}

export default CookiePolicy
